import { FeatureStyle, GEOMETRYTYPE } from "../featuretree/internal";
const POLYGONSYMBOLIZER = {
    filter: "",
    symbolizer: "polygon",
    params: {
        fill: [0.8, 1.0, 1.0, 0.4],
    },
};
const LINESYMBOLIZER = {
    filter: "",
    symbolizer: "line",
    params: {
        "stroke-width": 2,
        stroke: [0.2, 0.8, 0.8, 1],
    },
};
const POINTSYMBOLIZER = {
    filter: "",
    symbolizer: "point",
    params: {
        size: 8,
        stroke: [0.2, 0.8, 0.8, 1],
        "font-marker": {
            name: "circle",
            rotation: 0,
            fontsize: 8,
            anchor: ["center", "middle"],
        },
    },
};
const POLYGONSTYLE = new FeatureStyle({
    stylename: "layerstyle",
    rules: [POLYGONSYMBOLIZER, LINESYMBOLIZER, POINTSYMBOLIZER],
});
const LINESTYLE = new FeatureStyle({
    stylename: "layerstyle",
    rules: [LINESYMBOLIZER, POINTSYMBOLIZER],
});
const POINTSTYLE = new FeatureStyle({
    stylename: "layerstyle",
    rules: [POINTSYMBOLIZER],
});
export const DEFAULTLAYERSTYLE = {
    STYLE: POLYGONSTYLE,
    [GEOMETRYTYPE.POLYGON]: POLYGONSTYLE,
    [GEOMETRYTYPE.LINESTRING]: LINESTYLE,
    [GEOMETRYTYPE.POINT]: POINTSTYLE,
    [GEOMETRYTYPE.MULTILINESTRING]: LINESTYLE,
    [GEOMETRYTYPE.MULTIPOLYGON]: POLYGONSTYLE,
    [GEOMETRYTYPE.MULTIPOINT]: POINTSTYLE,
    [GEOMETRYTYPE.UNDEFINED]: POLYGONSTYLE,
    HIGHLIGHTSTYLE: new FeatureStyle({
        stylename: "highlightstyle",
        rules: [
            {
                filter: "",
                symbolizer: "point",
                params: {
                    size: 10,
                    stroke: [
                        1,
                        0.404,
                        0,
                        1
                    ]
                }
            },
            {
                filter: "",
                symbolizer: "line",
                params: {
                    "stroke-width": 2,
                    stroke: [
                        1,
                        0.404,
                        0,
                        1
                    ]
                }
            },
            {
                filter: "",
                symbolizer: "polygon",
                params: {
                    fill: [
                        1,
                        0.404,
                        0,
                        0.6
                    ]
                }
            }
        ]
    }),
    EMPTY: new FeatureStyle({
        stylename: "emptystyle",
        rules: [],
    }),
};
//# sourceMappingURL=defaultlayerstyles.js.map